import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage } from '../../helpers/Firebase';
import { servicePath, storagePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import { adminRoot } from "../../constants/defaultValues";
import {
    SUPPLIER_LIST,
    ADD_FORM,
    FORM_UPLOAD_SET
} from '../actions';

import {
    SupplierListSuccess,
    SupplierListError,
    AddFormSuccess,
    AddFormError,
    FormUploadSetSuccess,
    FormUploadSetError
} from '../actions';

export function* watchSupplierList() {
    yield takeEvery(SUPPLIER_LIST, onSupplierList);
}

export function* watchAddForm() {
    yield takeEvery(ADD_FORM, onAddForm);
}

export function* watchFormUploadSet() {
    yield takeEvery(FORM_UPLOAD_SET, onFormUploadSet);
}

const onSupplierListAsync = async (payload) => {
    const response = await fetch(servicePath + 'main/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


const onAddFormAsync = async (payload) => {
    const response = await fetch(servicePath + 'main/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onFormUploadSetAsync = async (file) => {
    var storageRef = storage.ref();
    let filename = file.name;
    console.log("Valor de storageRef" + storageRef);
    return await new Promise((success, reject) => {
        var uploadTask = storageRef.child(storagePath + '/forms/' + filename).put(file);

        uploadTask.on('state_changed',
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
            function (error) {
                reject({ name: filename, original: file.name, message: error.code, url: '', type: file.type, size: file.size, path: 'forms/' })
            },
            function () {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    success({ message: 'success', name: filename, original: file.name, url: downloadURL });
                });
            });
    });
};

function* onSupplierList(data) {
    try {
        const response = yield call(onSupplierListAsync, data.payload);
        yield put(SupplierListSuccess(response.data));
    } catch (error) {
        yield put(SupplierListError(error));
    }
}


function* onAddForm(data) {
    try {
        const response = yield call(onAddFormAsync, data.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
            window.location.replace("https://comunicacionesinfraigss.web.app/thankyou");
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(AddFormSuccess(response));
    } catch (error) {
        yield put(AddFormError(error));
    }
}

function* onFormUploadSet({ payload }) {
    const { file } = payload;
    try {

        const response = yield call(onFormUploadSetAsync, file);
        console.log("response" + JSON.stringify(response));
        if (response.message === 'success') {
            yield put(FormUploadSetSuccess(response));
            
        }
        else {
            yield put(FormUploadSetError(response));
        }
    } catch (error) {
        yield put(FormUploadSetError({ name: '', original: file.name, message: error, url: '', path: '' }))
    }
}


export default function* rootSaga() {
    yield all([
        fork(watchSupplierList),
        fork(watchAddForm),
        fork(watchFormUploadSet)
    ]);
}

